jQuery(function () {

    var accepted_strings = {
        filter: null,
        start_date: null,
        end_date: null
    };

    function pjaxComplete($pjax, location_filter, url_query, filter_query) {

        $pjax.removeClass('pjax-container--hide');
        var pages = jQuery('input[name="deal_cards_total_pages"]').val();

        if (location_filter) {
            jQuery('.paginator__container').find('input[name="filter"]').val(location_filter);
        } else {
            jQuery('.paginator__container').find('input[name="filter"]').val('');
            //console.log("No Location filter");
        }

        jQuery('.paginator__container').find('input[name="p"]').val(1);

        jQuery('.paginator__number-of-pages').html(pages);
        jQuery('.paginator__content').find('form').attr('data-total-pages', pages);

        if (pages == 1 || jQuery("input[name=p]").val() == pages) {
            jQuery('.paginator__next-link').addClass('paginator__next-link--disabled');
        }

        if (jQuery("input[name=p]").val() < pages) {
            jQuery('.paginator__previous-link').addClass('paginator__previous-link--disabled');
        }

        jQuery('.paginator__next-link').attr('href', '?p=' + jQuery('input[name="deal_cards_next"]').val() + filter_query);
        jQuery('.paginator__previous-link').attr('href', '?p=' + jQuery('input[name="deal_cards_previous"]').val() + filter_query);

        jQuery('.paginator__container').find('.paginator__previous-link').attr('data-page', jQuery('input[name="deal_cards_previous"]').val());
        jQuery('.paginator__container').find('.paginator__next-link').attr('data-page', jQuery('input[name="deal_cards_next"]').val());
    }

    function checkDateFilters($pjax) {
        var $date_filters = $pjax.find('.text-field--date-filter');
        var start_date = null;
        var end_date = null;
        var values = [];

        jQuery.each($date_filters, function (index, item) {
            var value = jQuery(item).val();
            var name = jQuery(item).attr('name');

            if ((name in accepted_strings) && accepted_strings.hasOwnProperty(name)) {
                accepted_strings[name] = value;
            }
        });
    }

    function composeUrl($pjax) {

        var current_url = window.location.href.split('?');
        var base_url = current_url[0];
        var new_url = '';
        var url_query = '?';

        var location_filter = $pjax.find('[name="filter"]').val();

        var current_strings = {};

        // check if the current URL has a query attached
        if (current_url[1]) {

            // separate the queries
            var queries = current_url[1].split('&');

            jQuery.each(queries, function (index, query_string) {
                var parts = query_string.split('=');
                current_strings[parts[0]] = parts[1];
            });
        }

        accepted_strings.filter = location_filter;

        checkDateFilters($pjax);

        // structure the new URL
        for (var property in accepted_strings) {
            if (accepted_strings.hasOwnProperty(property)) {

                if (accepted_strings[property]) {
                    url_query = url_query + property + '=' + accepted_strings[property] + '&';
                }
            }
        }

        // remove last ampersand
        url_query = url_query.substring(0, url_query.length - 1);

        new_url = base_url + url_query;

        return new_url;
    }

    jQuery(document).on('submit', '.deal-cards__date-filter-container', function (e) {

        e.preventDefault();

        var $container = jQuery(this).parents('.pjax-container');
        var $pjax = $container.find('#deal-cards-container');

        var new_url = composeUrl($container);

        $pjax.addClass('pjax-container--hide');

        $pjax.one('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd', function () {
            jQuery.pjax({
                container: '#' + $pjax[0].id,
                fragment: '#' + $pjax[0].id,
                scrollTo: false,
                url: new_url
            });
        });

        jQuery(document).one('pjax:complete', function (e) {
            pjaxComplete($pjax, accepted_strings.filter, new_url);
        });

    });

    jQuery(document).on('change', '.deal-cards__filter', function (e) {

        var $this = jQuery(this);
        var filter = $this.val();
        var $option = $this.find(':selected');
        var container = $option.data('container');
        var fragment = $option.data('fragment');
        var $pjax = jQuery(container);
        var $container = jQuery(this).parents('.pjax-container');

        var new_url = composeUrl($container);
        var filter_value = new_url.substring(new_url.indexOf("?"));

        $pjax.addClass('pjax-container--hide');

        jQuery('.paginator__next-link').removeClass('paginator__next-link--disabled');

        jQuery(document).one('pjax:complete', function (e) {
            pjaxComplete($pjax, filter, new_url, filter_value);
        });

        $pjax.one('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd', function () {

            jQuery.pjax({
                container: container,
                fragment: fragment,
                scrollTo: false,
                url: new_url
            });
        });

    });

    var offset = 0;
    jQuery('body').on('click', '.deal-cards__cta-load-more', function (e) {
        e.preventDefault();
        var get = {
            offset: offset
        };

        jQuery.get('/api/get_deal_cards', get, function (response) {
            var $response = jQuery(jQuery.parseHTML(response));

            jQuery('#deal-cards-container').append(response);
            offset = offset + 6;

            if ($response.find('.deal-cards__no-more').length == 1) {
                jQuery('.deal-cards__cta-load-more').addClass('deal-cards__cta-load-more--hidden');
            }
        });

        return false;
    });

    jQuery(document).on('pjax:end', function () {
        jQuery('.text-field--calendar').each(function () {
            jQuery(this).pikaday({
                format: "MM/DD/YYYY"
            });
        });
    });

});